import React from "react";
import styles from "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  InputToolbox,
  AttachmentButton,
  SendButton 


} from "@chatscope/chat-ui-kit-react";

import { Button, Input } from 'reactstrap';

import AuthService from "services/auth.service";
import './chatstyle.css';
import Timestamp from "react-timestamp";



const ENDPOINT = "http://50.50.50.50:9443";

const currentuser = AuthService.getCurrentUser() ? AuthService.getCurrentUser() : false
let username 

currentuser ? username = currentuser.username : username = 'Non-Authenticated User'

class Chatx extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      messages: [
        {
            "noteid": 18758,
            "id": "22515",
            "user": "test.agent",
            "note": "Here Is Case Notes",
            "resolution": "true",
            "createdAt": "2022-02-27T07:11:31.000Z",
            "updatedAt": "2022-02-27T07:11:33.000Z"
        },

    ],
      lastMessages: [],
      resnote:"Here Is Case Notes",
      CurrentUser:'test yser',
      isupdatedone:true,
      chatinput:"",


   };
    
  }









    componentDidMount() {
     // this.viewData(this.props.tktid);
    //  this.interval = setInterval(() => this.viewData(this.props.tktid), 30000);


   





    }

 componentWillUnmount(){




  //   clearInterval(this.interval);


    }











handleChatinput = (e) =>{ this.setState({[e.target.name]: e.target.value})};

    


    handleChange = (e) => {
      // get our form data out of state



        let sendmsg = new Promise((myResolve, myReject) =>{ 
  
if (this.state.chatinput.length > 0) {

          let cnotedata = {id:this.props.tktid,user:this.state.CurrentUser.username,note:this.state.chatinput}
        
        
          let Lastnotes = [...this.state.lastMessages];
                  // Add item to it
          
                  Lastnotes.push(cnotedata);
          console.log(Lastnotes)
                  // Set state

}
else {console.log('Blank Messages Are Not Allowed')}
              
                  
              myResolve('Done');
              myReject("Error");
            
          });
          
          sendmsg.then(
            (value)  =>{
              


                      



        
              this.setState({chatinput:''})
              
             // setTimeout(() => this.viewData(this.props.tktid), 500);
            },
            (error)  =>{console.log(error);}
          );
          





    }














  
  render(){
let sendButt = !this.props.noinput  ? <InputToolbox >
 
        <Input type="textarea" name="chatinput" placeholder="Type Note Here" bsSize="sm"  onChange={this.handleChatinput} value={this.state.chatinput} 
        
        style={{ height:'60px'}}
        
        
         />
<Button variant="primary"  onClick={this.handleChange} style={{backgroundColor:'rgb(130, 190, 80)', width:'100px', height:'40px'}} >Send</Button>


      </InputToolbox> : null;



const msgs =  this.state.messages.map(msg => 


  <Message    
            model={{
              message: msg.note,
              sentTime: "just now",
              sender: "Joe",
              position: "last",
  
            }}
  key={msg.noteid}

  >
  
  <Message.Header >
  <span> {msg.user} </span> <Timestamp date={msg.createdAt} />






  
  </Message.Header>
  </Message>)






    return(
<div style={{ position: "relative", height: "300px" }}>
  <MainContainer>
    <ChatContainer>
    



      <MessageList>
{msgs}




      </MessageList>







{sendButt}





    </ChatContainer>
  </MainContainer>

</div>
    )
  }
}



export default Chatx;